import * as XLSX from 'xlsx';
import { TableData,PdfCreateRequest } from './OCVTypes';

export const saveExcel = (reportname: string, tableObjects: any[],e?:React.MouseEvent) => {
  e?.preventDefault();
  const workbook = XLSX.utils.book_new();

  for (let i = 0; i < tableObjects.length; i++) {
    const headers = tableObjects[i].Item1;
    const tableValues = tableObjects[i].Item2;

    const data = [headers, ...tableValues.map((row: any) => row.map((cell: any) => {
      if (typeof cell === 'string') {
        return cell.replace(/<\/?[^>]+(>|$)/g, "").replace(/&nbsp;/g, '');
      }
      return cell;
    }))];

    const worksheet = XLSX.utils.aoa_to_sheet(data);
    XLSX.utils.book_append_sheet(workbook, worksheet, tableObjects[i].tableHeading);
  }

  const timeStamp = Math.floor(Date.now() / 1000);
  const filename = `Foundations_${reportname}_${timeStamp}.xlsx`;

  XLSX.writeFile(workbook, filename);
};
export const createAndDownloadPdf = async (createPdf: any, urlToPdf: string, reportName: string, setLoading?: (loading: boolean) => void) => {
  setLoading?.(true);
  const timestamp = Math.floor(Date.now() / 1000);
  const isSmartPaper = window.location.href.includes("SmartPaper");
  
  const filename = isSmartPaper 
    ? `${reportName}_smartpaper_${timestamp}.pdf`
    : `Foundations_${reportName}_${timestamp}.pdf`;

  const requestData: PdfCreateRequest = {
    OutputAbsPath: "",
    FileName: filename,
    ReportUrl: urlToPdf,
    HeaderHtml: "<h1></h1>",
    FooterHtml: "<h1>Page <span class='pageNumber'></span> of <span class='totalPages'></span>&nbsp;&nbsp</h1>",
    ApplicationURL: urlToPdf,
    AuthToken: "",
    isFullWidth: true
  };

  try {
    const response = await createPdf(requestData).unwrap();
    if (response?.data?.objId) {
      window.open(`/API/v3/pdf/file/${response.data.objId}`, '_blank');
      return true;
    }
    return false;
  } catch (error) {
    console.error('Error creating PDF:', error);
    return false;
  }
  finally{
    setLoading?.(false);
  }
};

export const processDisplayData = (externalResponse: any) => {
  const processData = (data: any): TableData => {
    const headers: string[] = [];
    const rows: any[][] = [];
    let hasLinkableFirstColumn = false;

    if (Array.isArray(data)) {
      // Get headers from first object
      if (data.length > 0) {
        Object.keys(data[0]).forEach(key => headers.push(key));
      }

      // Process rows
      data.forEach(item => {
        const row = headers.map(header => item[header] || '');
        // Check if first column should be linkable
        if (row[0] && typeof row[0] === 'string' &&
          row[0].match(/^[^<>:"/\\|?*]+\.[^<>:"/\\|?*]+$/)) {
          hasLinkableFirstColumn = true;
        }
        rows.push(row);
      });
    } else if (typeof data === 'object' && data !== null) {
      Object.keys(data).forEach(key => headers.push(key));
      rows.push(Object.values(data));
    }

    return {
      key: `table-${Date.now()}`, // Generate unique key
      Item1: headers,
      Item2: rows,
      Item3: new Array(rows.length).fill(false),
      Item4: new Array(rows.length).fill(hasLinkableFirstColumn),
      isDynamic: true,
      metadata: {
        fixedSection: false,
        ajaxOpts: externalResponse?.ajaxOpts
      }
    };
  };

  return {
    displayJSON: () => processData(externalResponse?.data || []),
    displayClinHX: () => {
      const ClinHXJSONs: any[] = [];
      const objs = externalResponse?.data?.Value;

      if (objs) {
        const objArray = Array.isArray(objs) ? objs : [objs];
        objArray.forEach(obj => {
          const ClinHXJSON: Record<string, any> = {};
          Object.entries(obj).forEach(([key, value]) => {
            if (!key.startsWith('@')) {
              ClinHXJSON[key] = value;
            }
          });
          ClinHXJSONs.push(ClinHXJSON);
        });
      }

      return processData(ClinHXJSONs);
    },
    displayTableFromJSON: () => processData(externalResponse?.data || [])
  };
};